import  useSync  from "./useSyncSdk"

const isDev = process.env.REACT_APP_IS_DEV === "1"

export default () => {

    const {getDecodeIos, getEncodeIos, getEncodexIos} = useSync()

    const getToken = () => {
        // return getTokenRaw()
        if (isDev) return window.localStorage.getItem("_token")
        return window?.gameBridge?.getToken?.()
    }

    const getAppid = () => {
        // return window.localStorage.getItem("app_id")
        if (isDev) return window.localStorage.getItem("app_id")
        return window?.gameBridge?.getAppid?.();
    }

    const openUrl = (url) => {
        // window.location.href = url;
        if (isDev) return window.location.href = url;
        window?.gameBridge?.openUrl?.(url);
    }

    const getApiDomain = () => {
        return window?.gameBridge?.getApiDomain?.()
    }

    const setToken = (token) => {
        if (isDev) return window.localStorage.setItem("_token", token)
    }
    const setAppid = (app_id) => {
        if (isDev) return window.localStorage.setItem("app_id", app_id)
    }

    const exit = () => {
        window?.gameBridge?.exit?.();
    }
    const canExit = () => {
        return window?.gameBridge?.exit !== undefined;
    }

    const getVer = () => {
        return window?.gameBridge?.getVer ? window?.gameBridge?.getVer() : "1";
    }

    const getPF = () => {
        return window?.gameBridge?.getPF?.() || "";
    }


    const getFP = () => {
        return window?.gameBridge?.getFP ? window?.gameBridge?.getFP() : "";
    }

    const getClickId = () => {
        return window?.gameBridge?.getClickId ? window?.gameBridge?.getClickId() : "0";
    }

    const getEncode = async (text) => {
        if (window.getPfByUserAgent() == 1) {
            return await getEncodeIos(text)
        }
        return window?.gameBridge?.getEncode?.(text);
    }

    const getDecode = async (text) => {
        if (window.getPfByUserAgent() == 1) {
            return await getDecodeIos(text)
        }
        return window?.gameBridge?.getDecode?.(text);
    }

    const getEncodex = async (text) => {
        if (window.getPfByUserAgent() == 1) {
            let rs = await getEncodexIos(text)
            return rs
        }

        return window?.gameBridge?.getEncodex?.(text);
    }

    const getR = () => {
        let chars = "abcdefghijklmnopqrstuvwxyz1234567890";
        let str = ""
        for (var i = 0; i < 5; i++) {
            str += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return str
    }







    

    return { getToken, getAppid, openUrl, setToken, setAppid, exit, canExit, getVer, getPF, getApiDomain, getFP, getClickId, getEncode, getDecode, getEncodex, getR }




}